import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=03054478&scoped=true"
import script from "./BookingList.vue?vue&type=script&lang=ts"
export * from "./BookingList.vue?vue&type=script&lang=ts"
import style0 from "./BookingList.vue?vue&type=style&index=0&id=03054478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03054478",
  null
  
)

export default component.exports